import i18n from 'utils/i18n';

const CLIENT_STATUS_KEYS = {
  0: 'payments.constants.statuses.standard',
  3: 'payments.constants.statuses.newClient',
};

export const getClientStatuses = () =>
  Object.entries(CLIENT_STATUS_KEYS).map(([value, key]) => ({
    value: Number(value),
    name: i18n.t(key),
  }));

export const setCategory = (category) => {
  const key = CLIENT_STATUS_KEYS[category];
  return key ? i18n.t(key) : '';
};
